function callWhenBrowserIsIdle(fn) {
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(fn, { timeout: 10000 });
  } else {
    setTimeout(() => {
      fn();
    }, 0);
  }
}

function callIfInputNotPendingOrIdle(fn) {
  if (!navigator?.scheduling?.isInputPending()) {
    fn();
  } else {
    callWhenBrowserIsIdle(fn);
  }
}

export { callIfInputNotPendingOrIdle, callWhenBrowserIsIdle };
